import { ArrowBack as IconArrowBack } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { generatePath, Link, To } from "react-router";

import { GaiaSubtleLink } from "~/modules/app/components/GaiaSubtleLink";
import { MapPanelHeader } from "~/modules/map/components/MapPanel";

import { PlannerV2AreaDetailPanelHeaderFragment } from "./fragments.generated";

type PlannerV2AreaDetailPanelHeaderProps = {
    area: PlannerV2AreaDetailPanelHeaderFragment;
    backHref: To;
};

export function PlannerV2AreaDetailPanelHeader({ area, backHref }: PlannerV2AreaDetailPanelHeaderProps) {
    return (
        <MapPanelHeader>
            <IconButton component={Link} color="inherit" to={backHref}>
                <IconArrowBack />
            </IconButton>

            <Stack paddingBlock={1} flexGrow={1}>
                <Typography variant="caption">
                    <GaiaSubtleLink
                        to={generatePath("/c/:clientSlug/p/:projectSlug", {
                            clientSlug: area.project.client.slug,
                            projectSlug: area.project.slug,
                        })}
                    >
                        {area.project.name}
                    </GaiaSubtleLink>{" "}
                    •{" "}
                    <GaiaSubtleLink to={generatePath("/c/:clientSlug", { clientSlug: area.project.client.slug })}>
                        {area.project.client.name}
                    </GaiaSubtleLink>
                </Typography>
                <Typography variant="h6">
                    <GaiaSubtleLink
                        to={generatePath("/c/:clientSlug/p/:projectSlug/map-editor/:layerId/:featureId", {
                            clientSlug: area.project.client.slug,
                            projectSlug: area.project.slug,
                            layerId: area.mapEditorFeature.layerId,
                            featureId: area.mapEditorFeature.id,
                        })}
                    >
                        {area.name}
                    </GaiaSubtleLink>
                </Typography>
            </Stack>
        </MapPanelHeader>
    );
}
